import { apiClient } from "./apiClient";

export async function saveDashboardLayout(accessToken, layoutJson) {
  const res = await apiClient.put(
    "/dashboard/layout",
    { layout_json: layoutJson },
    { headers: { Authorization: `Bearer ${accessToken}` } }
  );
  return res.data;
}

export async function getDashboardLayout(accessToken) {
  const res = await apiClient.get("/dashboard/layout", {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  return res.data;
}

// ---------- Edge'den gelen cihaz/tag (bulutta direkt cihaz yok, edge'deki cihazlar) ----------

/** Dashboard için erişilebilir edge listesi */
export async function getDashboardEdges(accessToken) {
  const res = await apiClient.get("/dashboard/edges", {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  return res.data?.items ?? res.data ?? [];
}

/** Seçilen edge'de (InfluxDB'de) görünen cihaz listesi */
export async function getDashboardEdgeDevices(accessToken, edgeId, since = "7d") {
  const res = await apiClient.get(`/dashboard/edges/${encodeURIComponent(edgeId)}/devices`, {
    headers: { Authorization: `Bearer ${accessToken}` },
    params: { since },
  });
  return res.data ?? [];
}

/** Seçilen edge + cihaz için tag listesi */
export async function getDashboardEdgeDeviceTags(accessToken, edgeId, deviceId, since = "7d") {
  const res = await apiClient.get(
    `/dashboard/edges/${encodeURIComponent(edgeId)}/devices/${encodeURIComponent(deviceId)}/tags`,
    {
      headers: { Authorization: `Bearer ${accessToken}` },
      params: { since },
    }
  );
  return res.data ?? [];
}

/** Seçilen edge + cihaz(lar) + tag(ler) için son değerler (gauge, sayı) */
export async function getDashboardDataLatest(accessToken, edgeId, deviceIds, tagNames = null) {
  const params = new URLSearchParams();
  params.set("edge_id", edgeId);
  params.set("device_ids", Array.isArray(deviceIds) ? deviceIds.join(",") : deviceIds);
  if (tagNames && tagNames.length) {
    params.set("tag_names", Array.isArray(tagNames) ? tagNames.join(",") : tagNames);
  }
  const res = await apiClient.get(`/dashboard/data/latest?${params}`, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  return res.data;
}

/** Seçilen edge + cihaz(lar) + tag(ler) için zaman serisi (grafik) */
export async function getDashboardDataSeries(accessToken, edgeId, deviceIds, tagNames, range = "1h") {
  const params = new URLSearchParams();
  params.set("edge_id", edgeId);
  params.set("device_ids", Array.isArray(deviceIds) ? deviceIds.join(",") : deviceIds);
  params.set("tag_names", Array.isArray(tagNames) ? tagNames.join(",") : tagNames);
  params.set("range", range);
  const res = await apiClient.get(`/dashboard/data/series?${params}`, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  return res.data;
}

/** Cihaz/tag başına aralık içi min/max (gauge otomatik aralığı) */
export async function getDashboardDataStats(accessToken, edgeId, deviceIds, tagNames, range = "24h") {
  const params = new URLSearchParams();
  params.set("edge_id", edgeId);
  params.set("device_ids", Array.isArray(deviceIds) ? deviceIds.join(",") : deviceIds);
  params.set("tag_names", Array.isArray(tagNames) ? tagNames.join(",") : tagNames);
  params.set("range", range);
  const res = await apiClient.get(`/dashboard/data/stats?${params}`, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  return res.data;
}

/** Edge cihazının CPU / RAM / disk doluluk yüzdeleri (Influx host_system) */
export async function getDashboardEdgeSystem(accessToken, edgeId) {
  const res = await apiClient.get(`/dashboard/edges/${encodeURIComponent(edgeId)}/system`, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  return res.data;
}

// ---------- Varlıklar tab aliases (same endpoints, names matching that UI's calls) ----------
export const listEdgeDevices = (accessToken, edgeId) => getDashboardEdgeDevices(accessToken, edgeId);
export const listDeviceTags = (accessToken, edgeId, deviceId) =>
  getDashboardEdgeDeviceTags(accessToken, edgeId, deviceId);
export const getEdgeDataLatest = (accessToken, edgeId, deviceIds) =>
  getDashboardDataLatest(accessToken, edgeId, deviceIds);

